{
  "brand": {
    "name": "Færdo"
  },
  "landing": {
    "description": "Færd means journey in Danish.",
    "tagline": "Start your journey now."
  },
  "locale": {
    "switchLabel": "Language",
    "en": "English",
    "pl": "Polski"
  },
  "consent": {
    "message": "We use analytics cookies to understand how you use this site and improve it. You can accept or decline.",
    "accept": "Accept",
    "decline": "Decline"
  }
}
